module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-48x48.4f4733669af2c9234dd5a61d2611ccf1.png";